import { useInView } from 'react-intersection-observer';
import { type ShopByLookContent, type ContentComponent } from '../../../../../types/construct.types';
import { HomeShopByLook } from '../../../../home-components/shop-by-look/shop-by-look/shop-by-look.component';

export const ShopByLookHandler: ContentComponent<ShopByLookContent> = ({ content }) => {
	const { ref, inView } = useInView({ triggerOnce: true });

	return <div ref={ref}>{inView && <HomeShopByLook content={content} />}</div>;
};
